import React from 'react';
import { ioT, shaker, carbon, reverseOsmosis } from 'images';
import styles from './styles.scss';

const SecondAnswer = () => (
  <div className={styles.secondAnswer}>
    <div className={styles.items}>
      <div className={styles.item}>
        <img src={ioT} alt="Monitoring" />
        <span>
          Smart
          <br />
          Monitoring
        </span>
      </div>
      <div className={styles.item}>
        <img src={shaker} alt="Shaker" />
        <span>Shaker Technology</span>
      </div>
    </div>
    <div className={styles.items}>
      <div className={styles.item}>
        <img src={carbon} alt="Carbon" />
        <span>Activated Carbon Filtration</span>
      </div>
      <div className={styles.item}>
        <img src={reverseOsmosis} alt="Osmosis" />
        <span>Reverse Osmosis Filtration</span>
      </div>
    </div>
  </div>
);

export default SecondAnswer;
